import httpClient from './httpClient';

export const UNIDAY_UNIVERSITY_ENDPOINT = '/backoffice/uniday-universities';
export const EXPORT_UNIDAY_UNIVERSITY_ENDPOINT = '/backoffice/exports/uniday-universities';
export const IMPORT_UNIDAY_UNIVERSITY_ENDPOINT = '/backoffice/imports/uniday-universities';

// สัญญา request / response ทั้งหมดอยู่ที่ docs/features/05-uniday-university.md §6
// ไม่มี delete โดยตั้งใจ — order เก่าอ้างถึง university อยู่ ลบแล้ว map ย้อนกลับไม่ได้ ใช้ status = 0 แทน
export const getUnidayUniversityListAPI = (params = {}) => httpClient.get(UNIDAY_UNIVERSITY_ENDPOINT, { params });
export const createUnidayUniversityAPI = (data) => httpClient.post(UNIDAY_UNIVERSITY_ENDPOINT, data);
export const updateUnidayUniversityAPI = (id, data) => httpClient.put(`${UNIDAY_UNIVERSITY_ENDPOINT}/${id}`, data);

// 200 ไม่มี body — BE ส่งไฟล์เข้าอีเมลคนกด
export const exportUnidayUniversityAPI = (params = {}) => httpClient.get(EXPORT_UNIDAY_UNIVERSITY_ENDPOINT, { params });

// 204 ไม่มี body — เข้า queue · 422 errors = array ของ string (มีเลขแถว)
export const importUnidayUniversityAPI = (file, config = {}) => {
	const formData = new FormData();
	formData.append('file', file);
	return httpClient.post(IMPORT_UNIDAY_UNIVERSITY_ENDPOINT, formData, config);
};
